import React from 'react';
import { Linkedin, Facebook } from 'lucide-react';
import { companyInfo } from '../mockData';

const LINKS = [
  { key: 'linkedin', label: 'LinkedIn', Icon: Linkedin, href: companyInfo.social.linkedin, brand: 'hover:bg-[#0A66C2] hover:border-[#0A66C2]' },
  { key: 'facebook', label: 'Facebook', Icon: Facebook, href: companyInfo.social.facebook, brand: 'hover:bg-[#1877F2] hover:border-[#1877F2]' },
];

export const SocialLinks = ({ variant = 'dark', showLabels = false }) => {
  const base = variant === 'dark'
    ? 'border-gray-700 text-gray-300 hover:text-white'
    : 'border-gray-200 bg-white text-gray-700 hover:text-white';
  return (
    <div className="flex flex-wrap gap-3" data-testid="social-links">
      {LINKS.map(({ key, label, Icon, href, brand }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`VB Global on ${label}`}
          data-testid={`social-link-${key}`}
          className={`inline-flex items-center gap-2 border-2 rounded-full transition-colors ${showLabels ? 'px-4 py-2 text-sm font-medium' : 'p-2.5'} ${base} ${brand}`}
        >
          <Icon className="w-5 h-5" />
          {showLabels && <span>{label}</span>}
        </a>
      ))}
    </div>
  );
};
